const {
  REACT_APP_GA_ID,
  REACT_APP_GOOGLE_API_KEY,
  REACT_APP_GTM_ID,
  REACT_APP_PRISMIC_REPO,
  REACT_APP_SENTRY_DSN,
  REACT_APP_SITE_AUTH,
  REACT_APP_SITE_TITLE,
  REACT_APP_SITE_VERSION,
  REACT_APP_RECAPTCHA_SITE_KEY,
} = process.env;

/**
 * `GA_ID` - Google Analytics ID
 * @constant gaid
 * @default
 */
export const GA_ID = REACT_APP_GA_ID || null;

/**
 * `GOOGLE_API_KEY` - API key for accessing Google Cloud services,
 * used for Google Maps
 * @constant recaptchasitekey
 * @default
 */
export const GOOGLE_API_KEY = REACT_APP_GOOGLE_API_KEY || null;

/**
 * `GTM_ID` - Google Tag Manager ID
 * @constant gtmid
 * @default
 */
export const GTM_ID = REACT_APP_GTM_ID || null;

/**
 * `SITE_AUTH` - Retrieves `REACT_APP_SITE_AUTH` from .env file,
 * key name used when saving authentication to local storage
 * @constant siteauth
 * @default
 */
export const SITE_AUTH = REACT_APP_SITE_AUTH || "auth";

/**
 * `SITE_TITLE` - Retrieves `REACT_APP_SITE_TITLE` from .env file,
 * used in <title> tag
 * @constant sitetitle
 * @default
 */
export const SITE_TITLE = REACT_APP_SITE_TITLE || "HOLT Used";

/**
 * `SITE_SHOW_STATUSES` - Statuses that should be displayed
 * @constant siteshowstatuses
 * @default
 */
export const SITE_SHOW_STATUSES = ["pending", "sold"];

/**
 * `SITE_VERSION` - current package.json version
 * @constant siteversion
 * @default
 */
export const SITE_VERSION = REACT_APP_SITE_VERSION || null;

/**
 * `RECAPTCHA_SITE_KEY` - Public API key for reCaptcha
 * @constant recaptchasitekey
 * @default
 */
export const RECAPTCHA_SITE_KEY = REACT_APP_RECAPTCHA_SITE_KEY || null;

/**
 * `SENTRY_DSN` - where to send Sentry events
 * @constant sentrydsn
 * @default
 */
export const SENTRY_DSN = REACT_APP_SENTRY_DSN || null;

/**
 * `PRISMIC_REPO` - name of Prismic content repository
 * @constant prismicapi
 * @default
 */
export const PRISMIC_REPO = REACT_APP_PRISMIC_REPO || null;

/**
 * `ATTRIBUTION_PARAMS` - expected analytics URL parameters
 * @constant trackingparams
 * @default
 */
export const ATTRIBUTION_PARAMS = [
  "dclid",
  "fbclid",
  "gbraid",
  "gclid",
  "igshid",
  "msclkid",
  "twclid",
  "wbraid",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "utm_company",
  "utm_team",
  "utm_goal",
  "utm_product",
  "utm_sku",
  "utm_location",
];
